import scrollDepth from 'scroll-depth';

import vars from '../helpers';

const scrollbar = window.Scrollbar.get($('.js-scroller').get(0));
const analytics = {
	spent15sec() {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	},
	logoClick() {
		ga('send', 'event', 'client link', 'logo header');
		ga('rbcspec.send', 'event', 'client link', 'click');
	},
	rbcClick() {
		ga('send', 'event', 'nav', 'rbc logo');
	},
	lidLinkClick(e) {
		ga('send', 'event', 'client link', 'lead link', $(e.currentTarget).text());
		ga('rbcspec.send', 'event', 'client link', 'click');
	},
	heroClick(e) {
		ga('send', 'event', 'nav', 'hero nav click', $(e.currentTarget).text());
	},
	heroShow(name) {
		ga('send', 'event', 'main', 'hero progress view', name, {
			nonInteraction: true,
		});
	},
	shareClick(e) {
		ga('send', 'event', 'share', 'project share', $(e.currentTarget).data('social'));
	},
	menuOpen() {
		ga('send', 'event', 'nav', 'menu open');
	},
	menuClose() {
		ga('send', 'event', 'nav', 'menu close');
	},
	menuClick(e) {
		ga('send', 'event', 'nav', 'menu item click', $(e.currentTarget).text().trim());
	},
	upClick() {
		ga('send', 'event', 'main', 'up button');
	},
	textLinkClick(e) {
		if ($(e.currentTarget).closest('.up').length) {
			return;
		}

		ga('send', 'event', 'client link', 'hero text link', `${$(e.currentTarget).closest('.case').find('.case__name').text().trim()} | ${$(e.currentTarget).text().trim()}`);
		ga('rbcspec.send', 'event', 'client link', 'click');
	},
	scrollDepth(e) {
		const steps = [25, 50, 75, 100];
		const percent = e.offset.y / e.limit.y * 100;

		steps.forEach((step) => {
			if (percent >= step && !window[`scrollDepth${step}`]) {
				window[`scrollDepth${step}`] = true;

				ga('send', 'event', 'Scroll Depth', 'Percentage', `${step}%`, {nonInteraction: false});
				ga('rbcspec.send', 'event', 'Scroll Depth', 'Percentage', `${step}%`, {nonInteraction: false});

				if (step === 100) {
					scrollbar.removeListener(analytics.scrollDepth);
				}
			}
		});
	},
};

setTimeout(analytics.spent15sec, 15000);

$('.header__project a').on('click', analytics.logoClick);
$('.header__rbc').on('click', analytics.rbcClick);
$('.intro__text a').on('click', analytics.lidLinkClick);
$('.intro__names a').on('click', analytics.heroClick);
$('.share button').on('click', analytics.shareClick);
$('.header__burger').on('click', analytics.menuOpen);
$('.menu__close').on('click', analytics.menuClose);
$('.menu__item').on('click', analytics.menuClick);
$('.up a').on('click', analytics.upClick);
$('.case').each((index, item) => {
	const $item = $(item);

	$item.on('inview', (event, isInView) => {
		if (isInView) {
			analytics.heroShow($item.find('.case__name').text());
			$item.off('inview');
		}
	});
});
$('.case a').on('click', analytics.textLinkClick);

if (vars.isMobile()) {
	scrollDepth({
		userTiming: false,
		pixelDepth: false,
		gtmOverride: true,
		eventHandler(data) {
			ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
			ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		},
	});
} else {
	scrollbar.addListener(analytics.scrollDepth);
}
